/** Redaction bitmap grades, coarse (100) → clean (null). Each step reads as a denoise pass. */
export const RESOLVE_GRADES = [100, 70, 50, 35, 20, 10, null] as const

export type Grade = (typeof RESOLVE_GRADES)[number]
